(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flow-cafe-calculator"] && !Shopify.designMode) return;
  try {
    
(() => {
  const money = new Intl.NumberFormat('en-CA', { maximumFractionDigits: 0 });
  const formatMoney = value => '$' + money.format(value);
  const periods = [d => 1, d => 5, d => 10, d => 52 / 12 * d, d => 13 * d, d => 26 * d];
  const recommendedUnits = cups => cups <= 40 ? [1, 2] : cups <= 80 ? [2, 3] : cups <= 120 ? [3, 4] : cups <= 159 ? [4, 5] : [4, 6];
  function init(root) {
    if (root.dataset.fsReady) return;
    root.dataset.fsReady = 'true';
    const find = selector => root.querySelector(selector);
    const cups = find('[data-cups]');
    const wage = find('[data-wage]');
    const days = find('[data-days]');
    const chart = find('[data-chart]');
    const wrap = find('[data-chart-wrap]');
    const tooltip = find('[data-tooltip]');
    const visual = find('[data-recommend-visual]');
    const buttons = [...root.querySelectorAll('[data-period]')];
    let selected = 3;
    let hoverDay = null;
    const maxDays = () => 26 * Number(days.value);
    const xForDay = n => 8 + (n - 1) / (maxDays() - 1) * 584;
    const yForDay = n => 200 - n / maxDays() * 174;
    const formatTime = hours => hours < 1 ? Math.round(hours * 60) + ' ' + root.dataset.minute : hours.toLocaleString('en-CA', { maximumFractionDigits: 1 }) + ' ' + root.dataset.hour;
    function marker(n) {
      const x = xForDay(n);
      find('[data-dot]').setAttribute('cx', x);
      find('[data-dot]').setAttribute('cy', yForDay(n));
      find('[data-guide]').setAttribute('x1', x);
      find('[data-guide]').setAttribute('x2', x);
    }
    function showHover(n) {
      hoverDay = Math.max(1, Math.min(maxDays(), Math.round(n)));
      marker(hoverDay);
      find('[data-guide]').style.display = 'block';
      const hours = Number(cups.value) * 30 * hoverDay / 3600;
      const value = hours * Number(wage.value);
      tooltip.replaceChildren();
      const amount = document.createElement('strong');
      amount.textContent = formatMoney(value);
      tooltip.append(amount, document.createElement('br'), document.createTextNode(formatTime(hours) + ' ' + root.dataset.after + ' ' + hoverDay + ' ' + (hoverDay === 1 ? root.dataset.openDay : root.dataset.openDays)));
      tooltip.style.display = 'block';
      const width = wrap.clientWidth;
      const x = xForDay(hoverDay) / 600 * width;
      tooltip.style.left = Math.max(0, Math.min(width - tooltip.offsetWidth, x - tooltip.offsetWidth / 2)) + 'px';
      tooltip.style.top = '0px';
      chart.setAttribute('aria-label', tooltip.textContent);
    }
    function hideHover() {
      hoverDay = null;
      tooltip.style.display = 'none';
      find('[data-guide]').style.display = 'none';
      marker(periods[selected](Number(days.value)));
    }
    function draw() {
      const c = Number(cups.value), w = Number(wage.value), d = Number(days.value);
      find('[data-cups-output]').textContent = c;
      find('[data-wage-output]').textContent = '$' + w;
      find('[data-days-output]').textContent = d;
      const [solid, total] = recommendedUnits(c);
      find('[data-recommend-count]').textContent = solid + '–' + total;
      const visualKey = solid + '-' + total;
      if (visual.dataset.visualKey !== visualKey) {
        const units = document.createDocumentFragment();
        for (let i = 0; i < total; i++) {
          const unit = document.createElement('span');
          unit.className = 'fs-calc__unit ' + (i < solid ? 'fs-calc__unit--solid' : 'fs-calc__unit--possible');
          const image = document.createElement('img');
          image.src = i < solid ? visual.dataset.renderSrc : visual.dataset.logoSrc;
          image.alt = '';
          image.width = i < solid ? 214 : 116;
          image.height = i < solid ? 650 : 1449;
          unit.append(image);
          units.append(unit);
        }
        visual.replaceChildren(units);
        visual.setAttribute('aria-label', solid + ' ' + root.dataset.solidUnits + ', ' + (total - solid) + ' ' + root.dataset.possibleUnits);
        visual.dataset.visualKey = visualKey;
      }
      find('[data-recommend-volume]').textContent = c + ' ' + root.dataset.drinksPerDay;
      const hours = c * 30 * periods[selected](d) / 3600;
      find('[data-time-saved]').textContent = formatTime(hours);
      find('[data-money-saved]').textContent = formatMoney(hours * w);
      find('[data-time-period]').textContent = root.dataset.over + ' ' + buttons[selected].textContent.trim();
      find('[data-money-period]').textContent = root.dataset.at + ' $' + w + ' / ' + root.dataset.hour;
      const line = 'M 8 200 L 8 ' + yForDay(1).toFixed(1) + ' L 592 26';
      find('[data-line]').setAttribute('d', line);
      find('[data-area]').setAttribute('d', line + ' L 592 200 Z');
      if (hoverDay === null) marker(periods[selected](d)); else showHover(hoverDay);
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
    }
    [cups, wage, days].forEach(input => input.addEventListener('input', draw));
    buttons.forEach((button, i) => button.addEventListener('click', () => { selected = i; draw(); }));
    chart.addEventListener('pointermove', event => {
      const bounds = chart.getBoundingClientRect();
      const x = Math.max(8, Math.min(592, (event.clientX - bounds.left) / bounds.width * 600));
      showHover(1 + (x - 8) / 584 * (maxDays() - 1));
    });
    chart.addEventListener('pointerleave', hideHover);
    chart.addEventListener('pointercancel', hideHover);
    chart.addEventListener('keydown', event => {
      if (event.key === 'Escape') { hideHover(); return; }
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      showHover((hoverDay === null ? Math.round(periods[selected](Number(days.value))) : hoverDay) + (event.key === 'ArrowRight' ? 1 : -1));
    });
    chart.addEventListener('blur', hideHover);
    draw();
  }
  function initAll(container = document) { container.querySelectorAll('[data-fs-calc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll()); else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flow-kickstarter-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fs-kickstarter-order')) {
  customElements.define('fs-kickstarter-order', class extends HTMLElement {
    connectedCallback() {
      if (this.stage) return;
      this.stage = this.querySelector('[data-stage]');
      this.units = [...this.querySelectorAll('[data-unit]')];
      this.funnels = [...this.querySelectorAll('[data-accessory]')];
      this.layouts = {
        1: [{x:50,y:48,h:84,z:5}],
        2: [{x:40,y:48,h:78,z:5},{x:60,y:48,h:78,z:5}],
        6: [{x:32,y:33,h:59,z:2},{x:48,y:33,h:59,z:2},{x:64,y:33,h:59,z:2},
            {x:36,y:53,h:59,z:5},{x:52,y:53,h:59,z:5},{x:68,y:53,h:59,z:5}]
      };
      this.onChange = event => {
        if (!event.target.matches('input[type="radio"]')) return;
        this.update(event.target);
      };
      this.addEventListener('change', this.onChange);
      this.resizeObserver = new ResizeObserver(() => this.position());
      this.resizeObserver.observe(this.stage);
      this.visibilityObserver = new IntersectionObserver(entries => {
        this.closest('.fs-order').classList.toggle('is-in-view', entries[0].isIntersecting);
      }, {threshold:0.05});
      this.visibilityObserver.observe(this.stage);
      this.update(this.querySelector('input:checked'));
    }
    position() {
      const {width, height} = this.stage.getBoundingClientRect();
      const list = this.layouts[this.quantity] || this.layouts[1];
      const place = (node, point, scale) => {
        node.style.setProperty('--tx', `${(point.x - 50) * width / 100}px`);
        node.style.setProperty('--ty', `${(point.y - 50) * height / 100}px`);
        node.style.setProperty('--scale', scale);
        node.style.zIndex = point.z;
      };
      this.units.forEach((unit, index) => {
        const point = list[index];
        place(unit, point || {x:50,y:60,z:1}, point ? point.h / 80 : .55);
        unit.style.opacity = point ? '1' : '0';
        unit.classList.toggle('is-visible', Boolean(point));
      });
      this.funnels.forEach((funnel, index) => {
        const included = this.quantity === 6;
        place(funnel, {x:index ? 74 : 40,y:83,z:9}, included ? 1 : .75);
        funnel.style.opacity = included ? '1' : '0';
        funnel.classList.toggle('is-visible', included);
      });
    }
    update(selected) {
      if (!selected) return;
      this.quantity = Number(selected.dataset.quantity);
      this.stage.dataset.quantity = String(this.quantity);
      this.stage.setAttribute('aria-label', selected.dataset.contents);
      this.querySelector('[data-caption]').textContent = selected.dataset.contents;
      this.querySelector('[data-total]').textContent = `CA$${selected.dataset.price}`;
      const retail = Number(selected.dataset.retail);
      const saving = retail - Number(selected.dataset.price);
      const amount = new Intl.NumberFormat('en-CA', {maximumFractionDigits:2}).format(saving);
      this.querySelector('.fs-order__retail s').textContent = `CA$${selected.dataset.retail}`;
      this.querySelector('[data-saving]').textContent = this.dataset.saveTemplate.replace('__AMOUNT__', amount);
      this.querySelector('[data-contents-text]').textContent = selected.dataset.contents;
      this.querySelector('[data-use-text]').textContent = selected.dataset.use;
      this.querySelector('[data-cta]').href = selected.dataset.url;
      const included = Number(selected.dataset.funnels) > 0;
      this.querySelector('[data-funnel-copy]').textContent = included ? this.dataset.included : this.dataset.optional;
      this.querySelector('[data-funnel-price]').textContent = included ? this.dataset.includedLabel : '+CA$20';
      this.position();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.removeEventListener('change', this.onChange);
      this.stage = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
